import { useMutation, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/idp/base';
import { type Activity, type Plan } from '@/data/idp/plans/interfaces';

export interface CreateActivityPayload {
  title: string;
  description?: string;
}

export const useCreatePlanActivity = (planId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateActivityPayload) => {
      const response = await falconClient.post(
        `${baseUrl}/plans/${planId}/activities`,
        {
          title: payload.title,
          description: payload.description,
        }
      );

      return response.data as Activity;
    },
    onSuccess: (updatedActivity: Activity) => {
      const planData = queryClient.getQueryData<Plan>([
        clientKeys.usePlanShow,
        planId,
      ]);

      if (planData) {
        queryClient.setQueryData<Plan>([clientKeys.usePlanShow, planId], {
          ...planData,
          activities: planData.activities.map((currentActivity) =>
            currentActivity.id === planId
              ? { ...currentActivity, ...updatedActivity }
              : currentActivity
          ),
        });
      }
      queryClient.invalidateQueries({
        queryKey: [clientKeys.usePlanActivitiesIndex, planId],
      });
      queryClient.invalidateQueries({
        queryKey: [clientKeys.usePlansIndex],
      });
      queryClient.invalidateQueries({
        queryKey: [clientKeys.usePlanShow, planId],
      });
    },
  });
};
